"use client";
import React from "react";
import { useTheme } from "@guberno/utils/theme";
import { AppContext } from "@guberno/utils/context";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { WcStack } from "@bpipartners/webui";

export const MainPageLayout = ({
  children,
  isPresentationView = false,
}: {
  children: React.ReactNode;
  isPresentationView?: boolean;
}) => {
  const theme = useTheme();
  const { localIsDrawerExpandedState } = React.useContext(AppContext);
  const [width, setWidth] = React.useState(theme.dimensions.baseWidth ? theme.dimensions.baseWidth : "100%");

  React.useEffect(() => {
    const calculatedWidth = `calc(100vw - ${
      isPresentationView
        ? 100
        : localIsDrawerExpandedState
        ? theme.dimensions.totalAppDrawerWidth
        : theme.dimensions.appDrawerCollapsedWidth
    }px)`;
    setWidth(calculatedWidth);
  }, [isPresentationView, localIsDrawerExpandedState]);

  return (
    <WcStack
      id="mainPageLayout"
      width={width}
      minWidth={theme.dimensions.minimumPageWidth}
      sx={{
        overflowX: "auto",
        overflowY: "hidden",
        marginX: 12,
      }}
    >
      {children}
    </WcStack>
  );
};
